"use client";

import { Minus, Plus } from "lucide-react";
import { useState } from "react";

import { FAQ } from "./data";

export function FaqAccordion() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="border-marketing-border border-t">
      {FAQ.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={item.q} className="border-marketing-border border-b">
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={() => {
                setOpen(isOpen ? null : i);
              }}
              className="group flex w-full items-center justify-between gap-4 py-4 text-left"
            >
              <span className="text-marketing-text group-hover:text-marketing-blue text-copy-16 font-medium tracking-[-0.01em] transition-colors sm:text-[16px]">
                {item.q}
              </span>
              <span className="text-marketing-text-secondary group-hover:text-marketing-blue shrink-0 transition-colors">
                {isOpen ? (
                  <Minus className="h-4 w-4" />
                ) : (
                  <Plus className="h-4 w-4" />
                )}
              </span>
            </button>
            <div
              className={`grid transition-[grid-template-rows] duration-300 ease-out motion-reduce:transition-none ${
                isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
              }`}
            >
              <div className="overflow-hidden">
                <p className="text-marketing-text-muted text-copy-14 max-w-[64ch] pb-5">
                  {item.a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
